import { FETCH_ALL_RIS_USERS_SUCCESS, FETCH_RIS_WITH_MIP_SUCCESS, FETCH_ALL_RIS_USERS_START, FETCH_ALL_RIS_USERS_ERROR } from "../../actions/admin/risActions";
import _ from 'lodash';

const INIT_STATE = {
    error: '',
    loading: false,
    message: '',
    ris: [],
    risMips: []
}

const risReducer = (state = INIT_STATE, action) => {
    let newState;
    let newUsers;
    let index;

    switch (action.type) {

        case FETCH_RIS_WITH_MIP_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.risMips = action.risMips.length > 0 ? [...action.risMips] : [];
            return newState;
        }

        case FETCH_ALL_RIS_USERS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_ALL_RIS_USERS_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.ris = action.ris.length > 0 ? [...action.ris] : [];
            return newState;
        }
        case FETCH_ALL_RIS_USERS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }

        default:
            return state;
    }
}

export default risReducer;
